<template>
  <div>
    <v-scroll-x-reverse-transition>
      <div class="popup popup-form white broker-calendar-panel" v-if="displayed">

        <div
          class="content-form-popup"
        >
          <calendar-custom v-if="!calendarLoading" @close="closecard" :calendar-events="events" :event-users="eventUsers" @event-deleted="deleteEvent($event)"/>
          <div class="bcg-loading" v-else><button type="button" class="calendar-loading-close" aria-label="Zavrieť kalendár" @click="closecard">×</button>
            <v-progress-circular
              class="loading-spinner"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-scroll-x-reverse-transition>
  </div>
</template>

<script>
import CalendarCustom from "../../../components/shared/CalendarCustom";
import { mapGetters } from "vuex";
import {getCalendarEvents, getUserProfileByID} from "../../../services/brokerService";

export default {
  name: "KartaKalendar",
  components: {
    CalendarCustom
  },
  created() {
    this.eventsRefreshInterval = setInterval(async () => {
      await this.$store.dispatch("clientsEvents/updateUserEvents");
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.eventsRefreshInterval);
  },
  computed: {
    calendarLoading() {
      return this.$store.getters["clientsEvents/getCalendarLoading"];
    },
    ...mapGetters({
      visibilityGetter: "appState/getCalendarVisible"
    }),
  },
  watch: {
    visibilityGetter (newVisibility) {
      this.displayed = newVisibility;
      if (!newVisibility) return;
      this.refreshEvents();
    },
  },
  methods: {
    deleteEvent(id) {
      const indexOfRemoved = this.events.map(e => e.id).indexOf(id);
      this.events.splice(indexOfRemoved, 1);
    },
    closecard () {
      this.$store.commit("clientsEvents/setConsultationClient", null);
      this.$store.commit("appState/setCalendarVisible", false);
    },
    async refreshEvents() {
      this.$store.commit("clientsEvents/setCalendarLoading", true);
      await this.$store.dispatch("clientsEvents/updateUserEvents");
      this.$store.commit("clientsEvents/setCalendarLoading", false);
    },
  },
  data: () => ({
    eventsRefreshInterval: null,
    loading: false,
    notClientIds: [],
    displayed: false,
    events: [],
    eventUsers: [],
  })
}
</script>

<style lang="scss" scoped>
.calendar-loading-close { position:absolute; top:20px; right:20px; width:34px; height:34px; font-size:24px; color:var(--app-text); }
.broker-calendar-panel { background:var(--app-bg)!important; border-left:1px solid var(--app-border); }
.bcg-loading {
  z-index: 9999;
  width: 100%;
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  width: min(1280px, calc(100vw - 72px));
  height: 100%;
  z-index: 100;
  overflow: hidden;
}

.content-form-popup {
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
}

@media (max-width: 767px) {
  .popup { width: 100%; }
  .content-form-popup { padding: 18px 14px; }
}
</style>
